// extracted by css-extract-rspack-plugin
export default {"label":"_1fb00b78"};